
export enum HierarchyGroupCategoryCd {
	OPERATIONS_AREA = 'OPERATIONS AREA',
	OPERATIONS_REGION = 'OPERATIONS REGION'}
